import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import useSettingsStyles from 'pages/pga-coach/settings/settings.styles'
import { SettingsSection } from 'pages/pga-coach/settings/settings-components'
import useStyles from './styles'

export default function FormContainer({
  children,
  eyebrow,
  subtitle,
  headerTitle,
  headerDescription,
  icon: Icon,
}) {
  const classes = useStyles()
  const settingsClasses = useSettingsStyles()
  const hasHeader = Icon || headerTitle || headerDescription

  const content = (
    <Box className={classes.formCardBody}>
      {hasHeader ? (
        <Box className={classes.optionHeader}>
          {Icon ? (
            <div className={classes.rowIcon}>
              <Icon />
            </div>
          ) : null}
          {headerTitle || headerDescription ? (
            <Box className={classes.rowBody}>
              {headerTitle ? (
                <Typography component="p" className={classes.rowTitle}>
                  {headerTitle}
                </Typography>
              ) : null}
              {headerDescription ? (
                <Typography component="p" className={classes.rowDescription}>
                  {headerDescription}
                </Typography>
              ) : null}
            </Box>
          ) : null}
        </Box>
      ) : null}
      <Box className={classes.optionControl}>{children}</Box>
    </Box>
  )

  if (!eyebrow) {
    return content
  }

  return (
    <SettingsSection
      eyebrow={eyebrow}
      subtitle={subtitle}
      classes={settingsClasses}
    >
      {content}
    </SettingsSection>
  )
}
